import React, { Fragment, useState } from 'react';
import { createPortal } from 'react-dom';
import MoveQuestionModal from '../move/MoveQuestionModal';

const MoveQuestionWrapper = ({ question }) => {
    const [showModal, setShowModal] = useState(false);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    return (
        <Fragment>
            <span className="dropdown-option move-modal-link link" onMouseDown={openModal}>Move</span>
            {showModal && createPortal(<MoveQuestionModal question={question} closeModal={closeModal} />, document.body)}
        </Fragment>
    );
};

export default MoveQuestionWrapper;
